module.exports = __webpack_public_path__ + "img/next.88f8321.png";